import React from 'react'
import { Alert } from '@mui/material'
import type { ControlTowerActionOutcome } from './controlTowerHelpers'

const OUTCOME_ALERT_RADIUS_PX = 12

interface ControlTowerActionOutcomeAlertProps {
  outcome: ControlTowerActionOutcome | null
  onClose: () => void
}

/** A card action's outcome until the facilitator closes it; nothing while there is none. */
export const ControlTowerActionOutcomeAlert: React.FC<ControlTowerActionOutcomeAlertProps> = ({ outcome, onClose }) => {
  if (!outcome) return null

  return (
    <Alert severity={outcome.severity} onClose={onClose} sx={{ borderRadius: `${OUTCOME_ALERT_RADIUS_PX}px` }}>
      {outcome.message}
    </Alert>
  )
}
